import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { navigationHandled, selectPendingNavigation } from "@/store/slices/navigationSlice";
import useLeaveWarning from "./LeaveWarning";

function AppRouteEffects() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const pendingNavigation = useAppSelector(selectPendingNavigation);

  useEffect(() => {
    if (!pendingNavigation) {
      return;
    }
    navigate(pendingNavigation.path, {
      replace: pendingNavigation.replace,
      state: pendingNavigation.state
    });
    dispatch(navigationHandled(pendingNavigation.id));
  }, [pendingNavigation, navigate, dispatch]);

  useLeaveWarning();

  return null;
}

export default AppRouteEffects;
